import { colors } from 'Constants/Colors';

export const alertStyle = {
  position: 'fixed',
  right: '1rem',
  bottom: '4rem',
  boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.1)',
  borderRadius: '8px',
  color: `${colors.BLACK}`,
  zIndex: '100',
};

export const successColor = {
  background: `${colors.GREEN_LIGHT}`,
};

export const errorColor = {
  background: `${colors.RED}`,
};

export const leadingIcon = {
  color: `${colors.BLACK}`,
};
